import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

import { createSwiper } from "../../utils/swiper";

export const RelatedPostsSlider = {
	swiper: null as Swiper | null,

	init(): void {
		this.swiper = createSwiper(
			'[data-swiper="related-posts"]',
			"post-card",
			{
				modules: [Autoplay, Navigation],
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 8,
					},
					768: {
						slidesPerView: 2.5,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				},
				centeredSlides: false,
				direction: "horizontal",
				loop: false,
				mousewheel: false,
				watchOverflow: true,
				navigation: {
					nextEl: "[data-swiper-control-next]",
					prevEl: "[data-swiper-control-prev]",
				},
			},
		);
	},
};
